import { Link } from 'react-router-dom';
import { videos, type VideoItem } from '@/mocks/videos';

function VideoCard({ video }: { video: VideoItem }) {
  return (
    <Link
      to={`/category/${video.categorySlug}`}
      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
      className="group block bg-background-50 rounded-xl overflow-hidden border border-background-200 transition-all duration-200 hover:border-primary-200 cursor-pointer"
      data-product-shop
    >
      {/* Thumbnail */}
      <div className="relative w-full aspect-video overflow-hidden bg-background-200">
        <img
          src={video.thumbnail}
          alt={video.title}
          title={`${video.title} - 蘑菇视频高清在线观看`}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
          loading="lazy"
        />
        {/* Duration badge */}
        <span className="absolute bottom-2 right-2 px-2 py-0.5 bg-black/75 text-background-50 text-xs rounded-md font-medium">
          {video.duration}
        </span>
        {/* Quality badge */}
        <span className="absolute top-2 left-2 px-2 py-0.5 bg-primary-500 text-background-50 text-xs rounded-md font-medium">
          {video.quality}
        </span>
        {/* Play overlay */}
        <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-200 bg-black/30">
          <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-500 text-background-50">
            <i className="ri-play-fill text-xl"></i>
          </div>
        </div>
      </div>

      {/* Info */}
      <div className="p-3 md:p-4">
        <h3 className="text-sm md:text-base font-medium text-foreground-900 line-clamp-2 mb-2 leading-snug group-hover:text-primary-600 transition-colors">
          {video.title}
        </h3>
        <div className="flex items-center justify-between text-xs text-foreground-500">
          <span className="flex items-center gap-1">
            <i className="ri-eye-line"></i>
            {video.views}
          </span>
          <span className="flex items-center gap-1 text-accent-500">
            <i className="ri-star-fill text-xs"></i>
            {video.rating}
          </span>
        </div>
      </div>
    </Link>
  );
}

export default function FeaturedVideos() {
  const featuredVideos = videos.slice(0, 8);

  return (
    <section className="w-full py-10 md:py-14 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-6">
          <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900">
            热门推荐
          </h2>
          <Link
            to="/category/dianying"
            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
            className="text-sm text-primary-500 hover:text-primary-600 font-medium flex items-center gap-1 whitespace-nowrap"
          >
            更多推荐
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {featuredVideos.map((video) => (
            <VideoCard key={video.id} video={video} />
          ))}
        </div>
      </div>
    </section>
  );
}